import { httpClient } from '../utils/providerHelpers/httpHelper';
import { API_AUTHORIZATION_URL } from '../config/api';
import { saveTokens, clearTokens } from '../utils/providerHelpers/tokensHelper';

const apiClient = httpClient({
  apiAuthUrl: API_AUTHORIZATION_URL,
  clearTokens,
  saveTokens,
});

export default apiClient;
